export default __webpack_public_path__ + "static/media/pelmeni.7521f6ed.jpeg";